export const storeRegistry = {};
